import { A } from 't-lib-ui/widgets';
import './FeedQuotaNote.css';

// Shown next to a disabled Follow button once the feed quota is reached. Links to the account page.
const FeedQuotaNote: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`feedQuotaNote${className ? ' ' + className : ''}`}>
    Max feeds reached. <A href="/a/account" internal>Manage in your account</A>
  </span>
);

export default FeedQuotaNote;
